function OurMission() {
  return (
    <>
      <div className="page-title" data-aos="fade">
        <div className="container">
          <nav className="breadcrumbs">
            <ol>
              <li><a href="/">Home</a></li>
              <li className="current">Our Mission</li>
            </ol>
          </nav>
          <h1>Our Mission</h1>
        </div>
      </div>

      <section id="our-mission" className="team section">
        <div className="container">
          <p>
            Our mission at CA Sanjay Prasad & Associates is to deliver dependable, value-added financial solutions that drive growth, ensure compliance, and build financial strength for our clients. We are dedicated to maintaining the highest standards of integrity, professionalism, and personalized service in every engagement.
          </p>
          <p>
            We strive to empower individuals, startups, and businesses by simplifying complex financial matters and providing actionable insights that support informed decision-making. Through continuous improvement and client-centric practices, we aim to be a trusted partner in every stage of our clients’ financial journeys.
          </p>
          <p>
            Our mission extends beyond numbers—we are committed to building relationships, fostering transparency, and contributing to the long-term success and sustainability of our clients and communities.
          </p>
        </div>
      </section>
    </>
  );
}

export default OurMission;
